import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=2881d4fb&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2881d4fb",
  null
  
)

export default component.exports